/* eslint-disable*/
import React, { useState, useEffect } from 'react';
import { useTheme } from '@material-ui/core/styles';
import { useParams, useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import CryptoJS from 'crypto-js';
import { Alert } from '@material-ui/lab';
import {
  Grid,
  Link,
  Typography,
  Box,
  TextField,
  InputLabel,
  Button,
  Container,
  Select,
  MenuItem,
  IconButton,
  Snackbar,
} from '@material-ui/core';
import * as Yup from 'yup';
import { InputAdornment } from '@material-ui/core';
import { ReactComponent as LocationIcon } from '../../../assets/images/LocationIcon.svg';
import { ReactComponent as TrashIcon } from '../../../assets/images/TrashWhite.svg';
import { Formik, Form, Field, FastField } from 'formik';
import Autocomplete from '@material-ui/lab/Autocomplete';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import PhotoCameraOutlinedIcon from '@material-ui/icons/PhotoCameraOutlined';
import PhotoCameraIcon from '@material-ui/icons/PhotoCamera';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import { showErrIfTouched } from '../../../utils';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import WarningRoundedIcon from '@material-ui/icons/WarningRounded';
import { ReactComponent as SnackBarTrashIcon } from '../../../assets/images/TrashIcon.svg';
import LanguageOutlinedIcon from '@material-ui/icons/LanguageOutlined';
import { ReactComponent as WebsiteIcon } from '../../../assets/images/WebsiteIcon.svg';
import { ReactComponent as PhoneIcon } from '../../../assets/images/PhoneIcon.svg';
import { ReactComponent as EmailIcon } from '../../../assets/images/EmailIcon.svg';

const CreateClubConnection = (props) => {
  const theme = useTheme();
  const key = 'iFrasCwdJh';
  let bytes = null;
  let loggedInUserData = null;
  const userCookie = Cookies.get('user');
  if (userCookie) {
    bytes = CryptoJS.AES.decrypt(userCookie, key);
    loggedInUserData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
  }

  const [clubConnectionDesc, setClubConnectionDesc] = React.useState('');
  const [categories] = useState([
    { id: 1, name: 'Sports & Recreation' },
    { id: 2, name: 'Arts & Culture' },
    { id: 3, name: 'Social & Community' },
    { id: 4, name: 'Professional & Business' },
    { id: 5, name: 'Health & Wellness' },
  ]);
  const [types] = useState([
    { id: 1, name: 'Club' },
    { id: 2, name: 'Connection' },
    { id: 3, name: 'Group' },
    { id: 4, name: 'Organization' },
  ]);
  const [contactMethods] = useState([
    { id: 1, name: 'Email' },
    { id: 2, name: 'Phone' },
    { id: 3, name: 'Website' },
    { id: 4, name: 'Social Media' },
  ]);

  const [initialValues, setInitialValues] = useState({
    clubConnectionName: '',
    category: '',
    type: '',
    description: '',
    phoneNumber: '',
    email: '',
    address: '',
    website: '',
    preferredContactMethod: '',
  });
  const [snackBarStatus, setSnackBarStatus] = useState(false);
  const [snackBarOpen, setSnackBarOpen] = useState(false);
  const maxCharacterCount = 700;
  const params = useParams();
  const navigate = useNavigate();
  const [images, setImages] = useState([]);
  const maxImages = 6;
  const maxFileSize = 5 * 1024 * 1024;
  const [uploadError, setUploadError] = useState(null);
  const formikRef = React.createRef();

  const validationSchema = Yup.object().shape({
    clubConnectionName: Yup.string().trim().required('Club/Connection name is required'),
    category: Yup.string().required('Category is required'),
    type: Yup.string().required('Type is required'),
    description: Yup.string().trim().required('Description is required'),
    email: Yup.string().email('Invalid email format').required('Email is required'),
    phoneNumber: Yup.string().required('Phone number is required'),
    preferredContactMethod: Yup.string().required('Preferred contact method is required'),
  });

  const handleTextAreaChange = (event, value) => {
    setClubConnectionDesc(value);
  };

  const handleClose = () => {
    setSnackBarOpen(false);
    if (snackBarStatus?.status) {
      goBack();
    }
  };

  const goBack = () => {
    navigate(`/app/community-details/${params?.id}#Section12`);
  };

  const handlePublish = async (values) => {
    try {
      const formData = new FormData();
      formData.append('communityId', params?.id);
      formData.append('repId', loggedInUserData?.id);
      formData.append('clubConnectionName', values?.clubConnectionName?.trim());
      formData.append('category', values?.category);
      formData.append('type', values?.type);
      formData.append('description', values?.description?.trim());
      formData.append('phoneNumber', values?.phoneNumber);
      formData.append('email', values?.email);
      formData.append('address', values?.address || '');
      formData.append('website', values?.website || '');
      formData.append('preferredContactMethod', values?.preferredContactMethod);

      images.forEach((file, index) => {
        formData.append(`imageList`, file);
      });

      // Here you would call your API to save the club/connection
      // const result = await addClubConnection(formData);

      // For now, simulate success
      setSnackBarStatus({ status: true, message: 'Club/Connection created successfully!' });
      setSnackBarOpen(true);
    } catch (e) {
      console.error(e);
      setSnackBarStatus({ status: false, message: 'Failed to create Club/Connection' });
      setSnackBarOpen(true);
    }
  };

  const isSupportedFileType = (file) => {
    const acceptedTypes = ['image/jpeg', 'image/jpg', 'image/png'];
    return acceptedTypes.includes(file.type);
  };

  const handleImageUpload = async (event) => {
    if (event) {
      const selectedFiles = event.target.files;
      let newImages = [];

      for (const file of selectedFiles) {
        if (!isSupportedFileType(file)) {
          setUploadError('Incorrect file type');
          return;
        }

        if (file.size > maxFileSize) {
          setUploadError('File size too large, max file size is 5mb');
          return;
        }
      }

      newImages = Array.from(selectedFiles);
      if (newImages.length + images.length > maxImages) {
        alert(`You can only select up to ${maxImages} images.`);
        return;
      }

      setUploadError(null);
      const imageList = [...images, ...newImages];
      setImages(imageList);
    }
  };

  const handleImageDelete = (index) => {
    const newImages = images.filter((_, i) => i !== index);
    setImages(newImages);
  };

  return (
    <Container>
      <Grid container className="PageSpacing FixedID">
        <Grid item xs={12}>
          <Grid item xs={12}>
            <Link underline="none" onClick={goBack} className="BackButtonWrapper">
              <Typography className="BackButton BackButtonMb" variant="body1">
                <ArrowBackIcon color="primary" className="BackButtonArrow" />
                Create your own Club/Connection
              </Typography>
            </Link>
          </Grid>
          <Grid container>
            <Grid item xs={12}>
              <Typography variant="caption" className="SubtitleCEV AmenitiesCEV">
                Club/connections are listed on the Community page in order of most recently added.
                Fields that are not required are marked as “Optional”
              </Typography>
            </Grid>

            <Grid item xs={12}>
              <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={handlePublish}
                innerRef={formikRef}
                enableReinitialize={true}
              >
                {(formikBag) => {
                  const {
                    handleSubmit,
                    setFieldValue,
                    isValid,
                    isSubmitting,
                    dirty,
                    touched,
                    handleChange,
                    values,
                    errors,
                  } = formikBag;
                  return (
                    <Form className="" onSubmit={handleSubmit} encType="multipart/form-data">
                      <Grid container className="AddAmenityForm">
                        <Grid item xs={12} className="commonFieldBox">
                          <InputLabel className="InputLabelFld" htmlFor="clubConnectionName">
                            Club/Connection Name
                          </InputLabel>
                          <FastField
                            as={TextField}
                            name="clubConnectionName"
                            id="outlined-basic"
                            variant="outlined"
                            type="text"
                            error={!!showErrIfTouched('clubConnectionName', errors, touched)}
                            helperText={showErrIfTouched('clubConnectionName', errors, touched)}
                            fullWidth
                            onChange={(e) => {
                              const value = e.target.value.replace(/^\s+/, '');
                              setFieldValue('clubConnectionName', value);
                            }}
                          />
                        </Grid>

                        <Grid container spacing={2}>
                          <Grid item xs={12} sm={6} className="commonFieldBox">
                            <InputLabel className="InputLabelFld" htmlFor="category">
                              Category
                            </InputLabel>
                            <Autocomplete
                              className="CommonAutocomplete"
                              id="category"
                              options={categories || []}
                              disableClearable={!values.category ? true : false}
                              value={categories.find((v) => v?.id == values?.category) || null}
                              getOptionLabel={(option) => option.name || ''}
                              renderInput={(params) => (
                                <TextField {...params} placeholder="" label="" variant="outlined" />
                              )}
                              onChange={(e, value) => {
                                setFieldValue('category', value?.id || '');
                              }}
                              popupIcon={<KeyboardArrowDownIcon />}
                            />
                          </Grid>
                          <Grid item xs={12} sm={6} className="commonFieldBox">
                            <Box display="flex" justifyContent="space-between">
                              <InputLabel className="InputLabelFld" htmlFor="type">
                                Type
                              </InputLabel>
                              <Typography variant="caption" component="div">
                                Requires a Category to be selected
                              </Typography>
                            </Box>
                            <Autocomplete
                              className="CommonAutocomplete"
                              id="type"
                              disabled={!values.category}
                              disableClearable={!values.type ? true : false}
                              options={types || []}
                              getOptionLabel={(option) => option.name || ''}
                              value={types.find((v) => v.id === values.type) || null}
                              onChange={(e, selectedOption) => {
                                setFieldValue('type', selectedOption?.id || '');
                              }}
                              renderInput={(params) => (
                                <TextField {...params} placeholder="" label="" variant="outlined" />
                              )}
                              popupIcon={<KeyboardArrowDownIcon />}
                            />
                          </Grid>
                        </Grid>

                        <Grid item xs={12} className="commonFieldBox">
                          <InputLabel className="InputLabelFld" htmlFor="description">
                            Description
                          </InputLabel>
                          <Box mb={1}>
                            <Typography variant="caption" component="div">
                              Briefly describe your group and include your usual meeting days or
                              times.
                            </Typography>
                          </Box>
                          <Field
                            as={TextField}
                            name="description"
                            value={values.description}
                            className="TextFieldTextarea"
                            fullWidth
                            multiline
                            minRows={8}
                            maxLength={700}
                            label=""
                            variant="outlined"
                            placeholder="Type your description..."
                            onChange={(e, value) => {
                              setFieldValue('description', e.target.value);
                              handleTextAreaChange(e, e.target.value);
                            }}
                            inputProps={{
                              maxLength: maxCharacterCount,
                            }}
                            helperText={`${maxCharacterCount - (values?.description || '').length}`}
                          />
                          {touched.description && errors.description && (
                            <Typography color="error">{errors.description}</Typography>
                          )}
                        </Grid>

                        <Grid item xs={12} className="commonFieldBox">
                          <Field name="imageList">
                            {({ field, form }) => (
                              <Box className="AmenityImagesContainer">
                                <Box display="flex" justifyContent="space-between">
                                  <InputLabel className="InputLabelFld" htmlFor="images">
                                    Images
                                  </InputLabel>
                                  <Typography variant="body2" component="div">
                                    {images.length}/{maxImages} Images
                                  </Typography>
                                </Box>
                                <Typography variant="body2">
                                  At least one image is required.
                                </Typography>
                                <Box className="AmenityImagesContent">
                                  {images.map((image, index) => (
                                    <Box key={index} elevation={3} className="AmenityImagesBox">
                                      <img
                                        src={URL.createObjectURL(image)}
                                        alt={`Image-${index + 1}`}
                                        style={{
                                          maxWidth: '100%',
                                          maxHeight: '100%',
                                        }}
                                        className="AmenityImg"
                                      />
                                      <IconButton
                                        onClick={() => handleImageDelete(index)}
                                        style={{
                                          position: 'absolute',
                                          top: 0,
                                          right: 0,
                                        }}
                                        className="AmenityImagesDeleteBox"
                                      >
                                        <TrashIcon />
                                      </IconButton>
                                    </Box>
                                  ))}

                                  {images.length < maxImages && (
                                    <label htmlFor="image-input" className="AmenityImagesUploadBox">
                                      <input
                                        type="file"
                                        id="image-input"
                                        accept=".jpg, .jpeg, .png"
                                        style={{ display: 'none' }}
                                        multiple
                                        onChange={(e) => {
                                          handleImageUpload(e);
                                        }}
                                      />
                                      {images.length === 0 ? (
                                        <Box elevation={3} className="AmenityAddImagesBox">
                                          <PhotoCameraOutlinedIcon
                                            color="primary"
                                            fontSize="large"
                                          />
                                          <Typography
                                            variant="body2"
                                            color="primary"
                                            component="div"
                                            className="AmenityAddImagesLabel"
                                          >
                                            ADD IMAGE
                                          </Typography>
                                        </Box>
                                      ) : (
                                        <Box elevation={3} className="AmenityAddImagesBoxSecond">
                                          <PhotoCameraIcon color="primary" fontSize="large" />
                                          <Typography
                                            variant="body2"
                                            color="primary"
                                            component="div"
                                            className="AmenityAddImagesLabel"
                                          >
                                            Add Photo
                                          </Typography>
                                        </Box>
                                      )}
                                    </label>
                                  )}
                                </Box>
                                {uploadError && (
                                  <Box mt={2}>
                                    <Typography
                                      variant="body2"
                                      component="div"
                                      className="CustomError"
                                    >
                                      {uploadError}
                                    </Typography>
                                  </Box>
                                )}
                              </Box>
                            )}
                          </Field>
                        </Grid>

                        <Grid item xs={12} className="commonFieldBox">
                          <Box display="flex" justifyContent="space-between">
                            <InputLabel className="InputLabelFld" htmlFor="preferredContactMethod">
                              Preferred Contact Method
                            </InputLabel>
                            <Typography variant="caption" component="div">
                              The selected option will become a required field
                            </Typography>
                          </Box>
                          <Autocomplete
                            className="CommonAutocomplete"
                            id="preferredContactMethod"
                            options={contactMethods || []}
                            disableClearable={!values.preferredContactMethod ? true : false}
                            value={
                              contactMethods.find((v) => v?.id == values?.preferredContactMethod) ||
                              null
                            }
                            getOptionLabel={(option) => option.name || ''}
                            renderInput={(params) => (
                              <TextField {...params} placeholder="" label="" variant="outlined" />
                            )}
                            onChange={(e, value) => {
                              setFieldValue('preferredContactMethod', value?.id || '');
                            }}
                            popupIcon={<KeyboardArrowDownIcon />}
                          />
                        </Grid>

                        <Grid item xs={12} className="commonFieldBox">
                          <InputLabel className="InputLabelFld" htmlFor="phoneNumber">
                            Phone Number
                          </InputLabel>
                          <FastField
                            as={TextField}
                            name="phoneNumber"
                            id="outlined-basic"
                            variant="outlined"
                            type="tel"
                            error={!!showErrIfTouched('phoneNumber', errors, touched)}
                            helperText={showErrIfTouched('phoneNumber', errors, touched)}
                            fullWidth
                            InputProps={{
                              startAdornment: (
                                <InputAdornment position="start">
                                  <PhoneIcon className="AmenityIcons" />
                                </InputAdornment>
                              ),
                            }}
                          />
                        </Grid>

                        <Grid item xs={12} className="commonFieldBox">
                          <InputLabel className="InputLabelFld" htmlFor="email">
                            Email
                          </InputLabel>
                          <FastField
                            as={TextField}
                            name="email"
                            id="outlined-basic"
                            variant="outlined"
                            type="email"
                            error={!!showErrIfTouched('email', errors, touched)}
                            helperText={showErrIfTouched('email', errors, touched)}
                            fullWidth
                            InputProps={{
                              startAdornment: (
                                <InputAdornment position="start">
                                  <EmailIcon className="AmenityIcons" />
                                </InputAdornment>
                              ),
                            }}
                          />
                        </Grid>

                        <Grid item xs={12} className="commonFieldBox">
                          <InputLabel className="InputLabelFld" htmlFor="address">
                            Address (Optional)
                          </InputLabel>
                          <FastField
                            as={TextField}
                            name="address"
                            id="outlined-basic"
                            variant="outlined"
                            type="text"
                            fullWidth
                            InputProps={{
                              startAdornment: (
                                <InputAdornment position="start">
                                  <LocationIcon className="AmenityIcons" />
                                </InputAdornment>
                              ),
                            }}
                          />
                        </Grid>

                        <Grid item xs={12} className="commonFieldBox">
                          <InputLabel className="InputLabelFld" htmlFor="website">
                            Website (Optional)
                          </InputLabel>
                          <FastField
                            as={TextField}
                            name="website"
                            id="outlined-basic"
                            variant="outlined"
                            type="url"
                            fullWidth
                            InputProps={{
                              startAdornment: (
                                <InputAdornment position="start">
                                  <WebsiteIcon className="FacilityIcons" />
                                </InputAdornment>
                              ),
                            }}
                          />
                        </Grid>

                        <Grid item xs={12}>
                          <Box className="Wrapper">
                            <Button
                              disabled={
                                !values.clubConnectionName ||
                                !values.description ||
                                !values.category ||
                                !values.type ||
                                !values.phoneNumber ||
                                !values.email ||
                                !values.preferredContactMethod ||
                                images.length === 0 ||
                                isSubmitting
                              }
                              variant="contained"
                              color="primary"
                              type="submit"
                              fullWidth
                            >
                              ADD
                            </Button>
                          </Box>
                        </Grid>
                      </Grid>
                      <Box component="div" display="flex" justifyContent="center" mt={0.5} mb={4}>
                        <Button
                          underline="none"
                          className="DeleteAmenityButton LinkTypeButton RedLineButton"
                          color="secondary"
                          variant="text"
                        >
                          Delete Club/Connection
                        </Button>
                      </Box>
                    </Form>
                  );
                }}
              </Formik>
            </Grid>
          </Grid>

          {/* Snackbar for success/error messages */}
          <Snackbar open={snackBarOpen} autoHideDuration={3000} onClose={handleClose}>
            <Alert
              elevation={6}
              variant="filled"
              onClose={handleClose}
              severity={snackBarStatus?.status ? 'success' : 'error'}
              icon={
                snackBarStatus?.status ? (
                  <CheckCircleIcon color="primary" fontSize="inherit" />
                ) : (
                  <WarningRoundedIcon color="secondary" fontSize="inherit" />
                )
              }
              action={
                <Link
                  color="primary"
                  underline="none"
                  aria-label="close"
                  onClick={handleClose}
                  className="AlertDismissButton"
                >
                  Dismiss
                </Link>
              }
            >
              {snackBarStatus?.message}
            </Alert>
          </Snackbar>
        </Grid>
      </Grid>
    </Container>
  );
};

CreateClubConnection.defaultProps = {};
export default CreateClubConnection;
